// chatSearchQuery.js — parse advanced search filters for ConversationFeed.

/** @typedef {{ text: string, author: 'user'|'assistant'|null, type: 'tool'|'error'|null, date: string|null }} ChatSearchFilters */

/**
 * Parse query like "author:user type:tool grep foo date:2026-06-01".
 * @param {string} raw
 * @returns {ChatSearchFilters}
 */
export function parseChatSearchQuery(raw) {
  const input = String(raw || '').trim();
  if (!input) return { text: '', author: null, type: null, date: null };

  let author = null;
  let type = null;
  let date = null;
  const textParts = [];

  for (const token of input.split(/\s+/)) {
    const authorMatch = token.match(/^author:(user|assistant|agente|agent)$/i);
    if (authorMatch) {
      author = /^user$/i.test(authorMatch[1]) ? 'user' : 'assistant';
      continue;
    }
    const typeMatch = token.match(/^type:(tool|error|erro|system)$/i);
    if (typeMatch) {
      type = /^tool$/i.test(typeMatch[1]) ? 'tool' : 'error';
      continue;
    }
    const dateMatch = token.match(/^date:(\d{4}-\d{2}-\d{2})$/);
    if (dateMatch) {
      date = dateMatch[1];
      continue;
    }
    textParts.push(token);
  }

  return { text: textParts.join(' ').trim(), author, type, date };
}

/** @param {import('./chatSearchQuery.js').ChatSearchFilters} filters @param {object} turn */
export function turnMatchesFilters(turn, filters, turnTextFn) {
  if (filters.author === 'user' && turn.side !== 'user') return false;
  if (filters.author === 'assistant' && turn.side !== 'assistant') return false;
  if (filters.type === 'tool' && !turn.messages.some((m) => m.role === 'tool')) return false;
  if (filters.type === 'error' && !turn.messages.some((m) => m.role === 'error')) return false;
  if (filters.date) {
    const iso = turn.messages[0]?.created_at;
    if (!iso || !String(iso).startsWith(filters.date)) return false;
  }
  if (filters.text) {
    const hay = turnTextFn(turn).toLowerCase();
    if (!hay.includes(filters.text.toLowerCase())) return false;
  }
  return true;
}
